import _forEach from "lodash/forEach";
import _includes from "lodash/includes";
import _isArray from "lodash/isArray";
import _isUndefined from "lodash/isUndefined";
import _keys from "lodash/keys";
import _pull from "lodash/pull";

import profileEvents from "./events/ProfileEvents";

var profileChangePasswordController = function (
    $scope,
    $state,
    profileFactory,
    redirectService,
    eventBus
) {
    $scope.profile = {
        username: "",
        password: "",
        newPassword: "",
        confirmPassword: ""
    };

    $scope.showSpinner = false;
    $scope.submitted = false;

    $scope.forceValidations = function (inputs) {
        inputs.forEach(function (input) {
            $scope.credentialForm[input].$touched = true;
            $scope.credentialForm[input].$dirty = true;
        });
    };

    retrieveUsername();

    /**
     * focus manager
     * indexed by fieldName
     * @type {{}}
     */
    $scope.focusMgr = {};

    $scope.removeInputFocus = function (event) {
        $scope.focusMgr[event.target.name] = false;
    };

    $scope.setInputFocus = function (event) {
        $scope.focusMgr[event.target.name] = true;
        $scope.credentialForm[event.target.name].$setTouched(true);
        $scope.credentialForm[event.target.name].$setDirty(true);
    };

    $scope.getFormGroupClass = function (fieldName) {
        if (_isUndefined($scope.credentialForm)) {
            return "";
        }
        var field = $scope.credentialForm[fieldName];
        var fieldFocused = $scope.focusMgr[fieldName] || false;
        var status = "";

        if (field && field.$invalid && field.$dirty && !fieldFocused) {
            status = "has-error";
        }

        if (field && field.$valid && field.$dirty) {
            status = "has-success";
        }
        return status;
    };

    $scope.fieldOnBlur = function (fieldName) {
        if (_isUndefined($scope.credentialForm)) {
            return "";
        }
        var field = $scope.credentialForm[fieldName];
        var fieldFocused = $scope.focusMgr[fieldName] || false;
        var status = "";

        if (field.$touched && field.$invalid && !fieldFocused) {
            status = "has-error";
        }
        return status;
    };

    $scope.getValidField = function (fieldName) {
        var field = $scope.credentialForm[fieldName].$valid;

        return field;
    };

    $scope.displayFieldMessages = function (fieldName) {
        var field = $scope.credentialForm[fieldName];
        if (_isUndefined($scope.credentialForm) || !field) {
            return true;
        }

        var conditions =
            (field.$invalid && field.$dirty) ||
            (field.$invalid && $scope.credentialForm.$submitted) ||
            field.$touched ||
            !field.$pristine;
        return conditions;
    };

    //$scope.displayValidMessage = function (fieldName) {
    //    var field = $scope.credentialForm[fieldName];
    //    var displayValidMessage = false;
    //
    //    if (field.$dirty && field.$valid) {
    //        displayValidMessage = true;
    //    }
    //
    //    return displayValidMessage;
    //};

    $scope.isDirty = function (fieldName) {
        if (_isUndefined($scope.credentialForm)) {
            return false;
        }
        var dirty =
            $scope.credentialForm[fieldName] !== undefined &&
            $scope.credentialForm[fieldName].$dirty;

        return dirty;
    };

    //$scope.displayFieldMessages = function (fieldName) {
    //    if (_isUndefined($scope.credentialForm)) {
    //        return '';
    //    }
    //    var field = $scope.credentialForm[fieldName];
    //    if (_isUndefined($scope.credentialForm) || !field) {
    //        return true;
    //    }
    //    var conditions = (field.$invalid && field.$dirty) || field.$touched || !field.$pristine;
    //
    //    return conditions;
    //};

    $scope.getFieldError = function (fieldName) {
        if (
            _isUndefined($scope.credentialForm) ||
            !fieldName ||
            _isUndefined($scope.credentialForm[fieldName])
        ) {
            return "";
        }
        return $scope.credentialForm[fieldName].$error;
    };

    /**
     * determine the validation error (style) class.
     * different class if one error vs multiples.
     */
    $scope.getValidationErrorClass = function (fieldName) {
        var styleName = "rule-validations";

        if (
            _isUndefined($scope.credentialForm) ||
            !fieldName ||
            _isUndefined($scope.credentialForm[fieldName])
        ) {
            return styleName;
        }
        var errs = $scope.credentialForm[fieldName].$error;
        var errorKeys = _keys(errs);

        if (fieldName === "confirmPassword") {
            //console.log('errorKeys',fieldName, errorKeys);
            var otherErrors = [
                "minLength",
                "numberPattern",
                "uppercasePattern",
                "specialCharPattern",
                "meetCondition1"
            ];
            if (includesAny(errorKeys, otherErrors)) {
                errorKeys = pullAll(errorKeys, otherErrors);
                //errorKeys.push("otherErrors");
            }
            //console.log('errorKeys after',fieldName, errorKeys);
        }
        var errorCnt = errorKeys.length;

        //if >1 errors, the style class should be bulleted.
        if (errorCnt > 1) {
            styleName = "form-validation-rule";
        }

        return styleName;
    };

    /**
     * returns true if "two" is in "one".
     */
    function includesAny(one, two) {
        var rc = false;
        //console.log('includesAny',one, two);
        if (one && two && _isArray(one)) {
            if (_isArray(two)) {
                _forEach(two, function (value) {
                    if (_includes(one, value)) {
                        //console.log('contains!',value,one);
                        rc = true;
                    }
                });
            } else {
                //console.log('contains!',two,one);
                rc = _includes(one, two);
            }
        }
        return rc;
    }

    /**
     * remove "two" from "one".
     * _pullAll(..) wasn't working
     */
    function pullAll(one, two) {
        if (one && two && _isArray(one)) {
            if (_isArray(two)) {
                _forEach(two, function (value) {
                    //console.log('removing ',value,'from',one);
                    _pull(one, value);
                });
            } else {
                //console.log('removing ',two,'from',one);
                _pull(one, two);
            }
        }
        return one;
    }

    function retrieveUsername() {
        profileFactory.retrieveUsername.query(
            {},
            function (data) {
                if (data !== null && data.status == "successful") {
                    if (data.username !== null) {
                        $scope.profile.username = data.username;
                    }
                }
            },

            function (error) {
                console.error("profileFactory.retrieveUsername - ERROR: ", error);
            }
        );
    }

    $scope.updatePassWord = function (flowName) {
        if ($scope.credentialForm.$valid) {
            $scope.showSpinner = true;
            eventBus.dispatch(profileEvents.FORCE_UPDATE_PASS_VALID, this);
            var updatePassWordData = {
                username: "NOT_NEEDED",
                currentpassword: $scope.profile.password,
                newpassword: $scope.profile.newPassword,
                flowName: flowName
            };

            profileFactory.updateForceChangePassword.query(
                updatePassWordData,
                function (data) {
                    //			$scope.showSpinner =false
                    if (flowName === "mfa") {
                        redirectService.redirect(data, "ALL");
                    }
                },

                function (response) {
                    $scope.showSpinner = false;
                    if (
                        response.headers("exception") !== null ||
                        response.headers("exceptionMessage") !== null
                    ) {
                        $scope.saveStatus = response.data.error.code;
                        $scope.saveStatusParams = response.data.error.errors[0];
                    }
                }
            );
        } else {
            // Some input is not valid, so we need to prompt the participant to fix the issue

            // Manually set the $dirty flag for each input in the form to trigger validation
            eventBus.dispatch(profileEvents.FORCE_UPDATE_PASS_INVALID, this);
            var inputs = ["password", "newPassword", "confirmPassword"];

            inputs.forEach(function (input) {
                $scope.credentialForm[input].$touched = true;
                $scope.credentialForm[input].$dirty = true;
            });
        }
    };

    $scope.cancelClick = function () {
        eventBus.dispatch(profileEvents.FORCE_CANCEL, this);
    };
    $scope.changeCurrentPasswordInput = function () {
        eventBus.dispatch(profileEvents.FORCE_CHANGE_CURRENT_PASS_INPUT, this);
    };
    $scope.changeNewPasswordInput = function () {
        eventBus.dispatch(profileEvents.FORCE_CHANGE_NEW_PASS_INPUT, this);
    };
    $scope.changeNewConfirmPasswordInput = function () {
        eventBus.dispatch(profileEvents.FORCE_CHANGE_NEW_CONFIRM_PASS_INPUT, this);
    };
};

profileChangePasswordController.$inject = [
    "$scope",
    "$state",
    "profileFactory",
    "redirectService",
    "eventBus"
];
export default profileChangePasswordController;
